import React, {PureComponent} from 'react';
import {Helmet} from 'react-helmet';
import {ImageresizeApi, Raven} from 'modules';
import {BannerAd, Loader } from 'components';
import {getUrlImageType, validateProcessResponse} from 'utils';

import ImageSelect from 'containers/ImageResize/ImageSelect';
import ImageAdjust from 'containers/ImageResize/ImageAdjust';
import ImageDownload from 'containers/ImageResize/ImageDownload';
import { NotFound } from "..";
export default class ImageResize extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      step: 'select',
      originalImage: null,
      imageEl: null,
      result: null,
      error: null
    };
  }
  
  componentDidMount() {
    const { match } = this.props;
    const imageId = match.params.imageId;
    const imageUrl = ImageresizeApi.getImageUrl(imageId);
    const $this = this;
    if(imageId !== undefined) {
      this.setState({
        step: 'loading'
      });
      ImageresizeApi.requestImageMetadata(match.params.imageId)
      .then((response) => {
        var xhr = new XMLHttpRequest(); 
        xhr.open('GET', imageUrl, true); 
        xhr.responseType = 'blob';
        xhr.onload = function() 
        {
            const blob = xhr.response;
            var img = new Image();
    
            img.onload = function(){
              console.log(img.height);
              console.log(img.width);
              const dimensions = {
                width: img.width,
                height: img.height
              }
              const image = {
                contentLength: blob.size,
                dimensions: dimensions,
                imageId: imageId,
                preview: imageUrl,
                type: getUrlImageType(response.permalink),
                uploadType: 'image',
                name: imageId
              }
              $this.handleImageUploaded([image]);
            }
    
            img.src = imageUrl;
        }
        xhr.send();
      })
      .catch(() => {
        this.setState({
          step: 'expired'
        });
      });
    }
  }

  resizeImage = (images) => {

    // TODO: Get a real progress indicator since this takes a while
    // Maybe this: https://tympanus.net/codrops/2014/04/09/how-to-create-a-circular-progress-button/
    this.setState({
      step: 'loading'
    });

    ImageresizeApi.editImages(images)
      .then(validateProcessResponse)
      .then(({ results }) => this.setState({
        step: 'download',
        result: {
          originalImage: this.state.originalImage,
          imageType: images[0].imageType,
          ...results[0]
        }
      }))
      .catch((error) => this.setState({
        step: 'error',
        error
      }));
  };

  handleImageUploaded = (images) => {

    console.log(images);
    // TODO: Get a real progress indicator since this takes a while
    // Maybe this: https://tympanus.net/codrops/2014/04/09/how-to-create-a-circular-progress-button/
    this.setState({
      step: 'loading'
    });

    // Create an image element and wait for it to load
    const imageEl = document.createElement('img');
    imageEl.src = images[0].preview;

    imageEl.addEventListener('load', () => this.setState({
      step: 'adjust',
      originalImage: images[0],
      imageEl
    }));
  };

  handleUploadErrors = (errors) => {
    if(errors[0] === 'multipleError') {
      this.setState({
        step: 'multipleError',
      })
    } else {
      this.setState({
        step: 'error',
        error: new Error(errors[0])
      })
      if(errors[0].message && errors[0].message.toLowerCase().search('pdf') === -1) {
        Raven.clog(errors[0], "ImageResize");
      }
    }
  };

  renderError() {
    const {error} = this.state;

    if(error.message.toLowerCase().search('pdf') !== -1) {
      return (
        <div className='error'>
          <p>PDF could not be resized:</p>
          <p className='errorMessage'>For PDF files, please use our <a href="/pdf-resize">PDF Resizer</a> page</p>
        </div>
      );
    } else {
      return (
        <div className='error'>
          <p>The image could not be resized:</p>
          <p className='errorMessage'>{error.message}</p>
        </div>
      );
    }
  }

  renderMultipleError() {
    return (
      <div className='error'>
        <p>This page support one image at a time.</p>
        <p className='errorMessage'>
          For bulk edits, please use <a href="https://imageresize.org/bulk-resize">Bulk Resize page</a>
        </p>
      </div>
    );
  }

  renderStep() {
    const {step, originalImage, imageEl, result} = this.state;

    switch (step) {
      case 'select':
        return <ImageSelect onErrors={this.handleUploadErrors} onDone={this.handleImageUploaded} />;
      case 'adjust':
        return <ImageAdjust originalImage={originalImage} image={imageEl} resizeImage={this.resizeImage} />;
      case 'download':
        return <ImageDownload result={result} />;
      case 'error':
        return this.renderError();
      case 'multipleError':
        return this.renderMultipleError();
      case 'loading':
        return <Loader />;
      case 'expired':
        return <NotFound text="Original image expired, please re-upload to edit" />;
      default:
        return null;
    }
  }

  render() {
    const shareUrl = ImageresizeApi.BASE_URL;
    const title = 'Image resize, edit, and crop online | ImageResize.org';
    const desc = 'A simple online image editor to crop and resize images. Also support image manipulations such as flip, rotate, compress or convert images.';
    return (
      <div>
        <Helmet>
          <title>{title}</title>
          <meta
            name="description"
            content={desc}
          />
          <meta property="og:url" content={shareUrl} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content={title} />
          <meta property="og:description" content={desc} />
          <meta property="og:image" content="/social.png" />   
          
        </Helmet>
        <BannerAd />
        {this.renderStep()}

      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/ImageResize/index.jsx